import { useLocation } from 'react-router-dom';
import routes from 'routes/routes';

import type { Route } from '../routes/routes';

const useCurrentRoute = (): Route => {
  const location = useLocation();

  let currentRoute = routes[location.pathname];
  if (!currentRoute) {
    Object.values(routes).forEach((route) => {
      if (route.regex?.test(location.pathname)) {
        currentRoute = route;
      }
    });
  }
  if (!currentRoute) {
    currentRoute = routes[`/${location.pathname.split('/')[1]}`];
  }
  if (!currentRoute) {
    return routes.error;
  }
  return currentRoute;
};

export default useCurrentRoute;
